<template>
  <div>
    <div class="main-wrapper">
      <!--begin::sidebar-->
      <sidebar-component classMenu="DetailMonitoring"></sidebar-component>
      <!--end::sidebar-->

      <div class="page-wrapper">
        <!--begin::navbar-->
        <navbar-component></navbar-component>
        <!--end::navbar-->

        <!--begin::content-->
        <div class="page-content">
          <div
            class="
              d-flex
              justify-content-between
              align-items-center
              flex-wrap
              grid-margin
            "
          >
            <div class="col-lg-12 col-xl-12 stretch-card">
              <div class="card">
                <div class="card-body">
                  <div class="row mb-3">
                    <div class="col-lg-2 col-md-12 col-sm-12 col-xs-12">
                      <h5 class="mb-12 mb-md-0">Detail Monitoring</h5>
                    </div>

                    <!-- <div class="col-lg-1 col-md-12 col-sm-12 col-xs-12">
                      <div class="input-group float-end">
                        <button
                          v-if="isMaps"
                          class="btn btn-primary btn-float"
                          @click="btnMaps(false)"
                        >
                          Hide Maps
                        </button>
                        <button
                          v-if="!isMaps"
                          class="btn btn-success btn-float"
                          @click="btnMaps(true)"
                        >
                          Show Maps
                        </button>
                      </div>
                    </div> -->

                    <div class="col-lg-2 col-md-12 col-sm-12 col-xs-12">
                      <div class="input-group">
                        <input
                          type="text"
                          class="form-control"
                          id="navbarForm"
                          v-model="vehicle_no"
                          readonly
                        />
                      </div>
                    </div>

                    <div class="col-lg-3 col-md-12 col-sm-12 col-xs-12">
                      <div class="input-group">
                        <date-range-picker
                          style="width: 100%"
                          @change="pickupChange"
                          control-container-class="form-control"
                          :locale-data="locale"
                          v-model="pickupdestination"
                          :opens="opens"
                          :singleDatePicker="false"
                          :timePicker24Hour="true"
                          :timePicker="true"
                          :showWeekNumbers="false"
                        >
                        </date-range-picker>
                      </div>
                    </div>

                    <div class="col-lg-1 col-md-12 col-sm-12 col-xs-12">
                      <div class="input-group float-end">
                        <button
                          class="btn btn-primary btn-float"
                          @click="filterMap()"
                        >
                          Go
                        </button>
                      </div>
                    </div>

                    <div
                      class="col-lg-3 col-md-12 col-sm-12 col-xs-12 float-end"
                    >
                      <div class="input-group">
                        <!-- <v-select
                          :options="fetchStatus"
                          v-model="status"
                          label="status_name"
                          return-object
                        >
                        </v-select> -->

                        <select
                          class="form-select form-select-lg"
                          name="status"
                          v-model="forms.tms_status"
                        >
                          <option
                            v-for="(item, index) in fetchStatus"
                            v-bind:key="index"
                            :style="{
                              color: item.status_color,
                            }"
                          >
                            {{ item.status_name }}
                          </option>
                        </select>

                        <button
                          class="btn btn-primary btn-xs"
                          type="button"
                          @click="updateStatus"
                        >
                          Update Status
                        </button>
                      </div>
                    </div>
                  </div>

 
    <div class="controls">
      <button @click="play()">Play</button>
      <button @click="pause()">Pause</button>
      <button @click="reset()">Reset</button>
      <button @click="next()">Next</button>
      <button @click="prev()">Previous</button>
      <button @click="fast()">Fast</button>
      <span id="speed">Speed: 1x</span>
      <button @click="slow()">Slow</button>
    </div>

<div id="map" class="map"></div>
 

                  <div class="row" v-if="isMaps">
                    <gmap-map
                      :zoom="5"
                      :center="center"
                      style="width: 100%; height: 400px"
                      map-type-id="terrain"
                    >
                      <!-- <gmap-marker
                        :key="index"
                        v-for="(gmp, index) in markers"
                        :position="gmp.position"
                        @click="center = gmp.position"
                      >
                        <gmap-info-window :opened="true">
                          <span
                            class="badge"
                            :style="{
                              'background-color': 'white',
                              color: 'black',
                            }"
                            :opened="false"
                          >
                            {{ gmp.position.label }}
                          </span>
                        </gmap-info-window>
                      </gmap-marker> -->
                      <gmap-polygon :paths="paths"></gmap-polygon>
                      <DirectionsRenderer
                        travelMode="DRIVING"
                        :origin="startLocation"
                        :destination="endLocation"
                        :waypoints="waypnt"
                        :optimizeWaypoints="true"
                      />
                    </gmap-map>
                  </div>

                  <br />

                  <ul class="nav nav-tabs" id="myTab" role="tablist">
                    <li class="nav-item">
                      <a
                        class="nav-link active"
                        id="basicinfo-tab"
                        data-bs-toggle="tab"
                        href="#basicinfo"
                        role="tab"
                        aria-controls="basicinfo"
                        aria-selected="true"
                        >Basic Info</a
                      >
                    </li>
                    <li class="nav-item">
                      <a
                        class="nav-link"
                        id="tripanalysis-tab"
                        data-bs-toggle="tab"
                        href="#tripanalysis"
                        role="tab"
                        aria-controls="tripanalysis"
                        aria-selected="false"
                        >Trip Analysis</a
                      >
                    </li>
                    <li class="nav-item">
                      <a
                        class="nav-link"
                        id="onetime-tab"
                        data-bs-toggle="tab"
                        href="#onetime"
                        role="tab"
                        aria-controls="onetime"
                        aria-selected="false"
                        >Ontime Analysis</a
                      >
                    </li>

                    <li class="nav-item">
                      <a
                        class="nav-link"
                        id="gpserror-tab"
                        data-bs-toggle="tab"
                        href="#gpserror"
                        role="tab"
                        aria-controls="gpserror"
                        aria-selected="false"
                        >Gps Error Reporting</a
                      >
                    </li>

                    <!-- <li class="nav-item">
                      <a
                        class="nav-link"
                        id="gpserror-tab"
                        data-bs-toggle="tab"
                        href="#triphistory"
                        role="tab"
                        aria-controls="triphistory"
                        aria-selected="false"
                        >Trip history</a
                      >
                    </li> -->
                  </ul>
                  <div
                    class="tab-content border border-top-0 p-3"
                    id="myTabContent"
                  >
                    <div
                      class="tab-pane fade show active"
                      id="basicinfo"
                      role="tabpanel"
                      aria-labelledby="basicinfo-tab"
                    >
                      <basic-info-component
                        :data="forms"
                        :detailMonitoring="detailMonitoring"
                        :detailOrder="fetchOrder"
                      ></basic-info-component>
                    </div>
                    <div
                      class="tab-pane fade"
                      id="tripanalysis"
                      role="tabpanel"
                      aria-labelledby="tripanalysis-tab"
                    >
                      <trip-analysis-component :detailOrder="fetchTripAnalysis" ></trip-analysis-component>
                    </div>

                    <div
                      class="tab-pane fade"
                      id="onetime"
                      role="tabpanel"
                      aria-labelledby="onetime-tab"
                    >
                      <on-time-analysis-component-1></on-time-analysis-component-1>
                      <br />
                      <br />

                      <on-time-analysis-component-2></on-time-analysis-component-2>
                    </div>
                    <div
                      class="tab-pane fade"
                      id="gpserror"
                      role="tabpanel"
                      aria-labelledby="gpserror-tab"
                    >
                      <gps-error-reporting-component></gps-error-reporting-component>
                    </div>
                    <!-- <div
                      class="tab-pane fade"
                      id="triphistory"
                      role="tabpanel"
                      aria-labelledby="triphistory-tab"
                    >
                      <trip-history-component></trip-history-component>
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::content-->

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>

<script>
import sidebarComponent from "@/components/_partials/_sidebar";
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
import basicInfoComponent from "@/components/dasboard-ct/basicinfo.vue";
import tripAnalysisComponent from "@/components/dasboard-ct/tripAnalysis.vue";
import onTimeAnalysisComponent from "@/components/dasboard-ct/onTimeAnalysis.vue";
import onTimeAnalysisComponent_ from "@/components/dasboard-ct/onTimeAnalysis_.vue";
import DirectionsRenderer from "@/middleware/DirectionsRenderer_";
import gpsErrorReportingComponent from "@/components/dasboard-ct/gpsErrorReporting.vue";
// import tripHistoryComponent from "@/components/dasboard-ct/tripHistory.vue";
// import {
//   TravelMarker,
//   TravelMarkerOptions
// } from 'travel-marker';
import moment from "moment";

import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";

export default {
  name: "MapContainer",
  components: {
    "sidebar-component": sidebarComponent,
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
    "basic-info-component": basicInfoComponent,
    "trip-analysis-component": tripAnalysisComponent,
    "on-time-analysis-component-1": onTimeAnalysisComponent,
    "on-time-analysis-component-2": onTimeAnalysisComponent_,
    "gps-error-reporting-component": gpsErrorReportingComponent,
    // "trip-history-component":tripHistoryComponent,
    // multiselect: multiselect,
    DirectionsRenderer,
    DateRangePicker,
  },
  data() {
    const startDate = new Date();
    const endDate = new Date();
    startDate.setDate(startDate.getDate() - 1);

    const mapMarkerIcon = require("../../assets/icontruck.png");
    return {
      markers: [],
      waypnt: [],
      opens: "center",
      locale: {
        format: "dd-mm-yyyy H:MM:ss",
      },
      pickupdestination: {
        startDate,
        endDate,
      },
      dataAll: "",
      paths: [],
      zoom: 3,
      isLoading: false,
      totalRecords: 0,
      openedMarkerID: true,
      markerOption: {
        url: mapMarkerIcon,
        size: { width: 30, height: 30, f: "20px", b: "20px" },
        scaledSize: { width: 30, height: 30, f: "20px", b: "20px" },
        rotation: 45,
      },

      branch: [],
      currentDate: moment(String(new Date())).format("YYYY-MM-DD"),
      truck: [],
      status: [],
      fetchBranch: [],
      fetchTruck: [],
      fetchStatus: [],
      fetchOrder: [],
      options: [],
      maxToasts: 100,
      position: "up right",
      closeBtn: true,
      isMaps: false,
      errors: [],
      featchTruck: [],
      featchStatus: [],
      featchBranch: [],
      langs: ["id", "en"],
      name: "",
      startLocation: null,
      endLocation: null,
      center: {
        lat: -2.548926,
        lng: 118.0148634,
      },
      serverParams: {
        columnFilters: {},
        sort: {
          field: "",
          type: "",
        },
        page: 1,
        per_page: 10,
      },

      locationMarkers: [],
      locations: [],
      locPlaces: [],
      realMonitoring: [],
      branchFilter: [],
      type_truckFilter: [],
      statusFilter: [],
      searchVhicle: "",
      rowsTable: [],
      fetchTripAnalysis: [],
      rows: [],
      vehicle_no: "B9204FYV",
      forms: [],
      detailMonitoring: [],
      speedMultiplier:1,
      map:null,
      line:null,
      marker:null,
      directionsService:null,
      TravelMarker:null,
      locationData : [[51.51324,-0.09909000000000001],[51.5133,-0.09908],[51.5133,-0.09908],[51.513290000000005,-0.09895000000000001],[51.513290000000005,-0.09885000000000001],[51.513290000000005,-0.09871],[51.513290000000005,-0.09861],[51.513290000000005,-0.0985],[51.513290000000005,-0.09838000000000001],[51.51328,-0.09826000000000001],[51.51328,-0.09826000000000001],[51.5133,-0.09816000000000001],[51.51332000000001,-0.0981],[51.51334000000001,-0.09806000000000001],[51.51339,-0.098],[51.513400000000004,-0.09791000000000001],[51.51342,-0.09781000000000001],[51.51343000000001,-0.09767],[51.513450000000006,-0.09756000000000001],[51.51346,-0.09748000000000001],[51.51346,-0.09741000000000001],[51.513470000000005,-0.09732],[51.51344,-0.09719000000000001],[51.51342,-0.09705000000000001],[51.51341000000001,-0.09694000000000001],[51.51339,-0.09681000000000001],[51.513360000000006,-0.09648000000000001],[51.51335,-0.09634000000000001],[51.51335,-0.09634000000000001],[51.51342,-0.09634000000000001],[51.513470000000005,-0.09634000000000001],[51.51350000000001,-0.09633000000000001],[51.513540000000006,-0.09634000000000001],[51.513580000000005,-0.09634000000000001],[51.51364,-0.09636],[51.51368,-0.09637000000000001],[51.513720000000006,-0.09638000000000001],[51.51375,-0.09639],[51.5138,-0.09642],[51.513830000000006,-0.09643],[51.513850000000005,-0.09644000000000001],[51.513870000000004,-0.09646],[51.51391,-0.09649],[51.513960000000004,-0.09652000000000001],[51.51399000000001,-0.09656],[51.514030000000005,-0.09659000000000001],[51.514120000000005,-0.09671],[51.514160000000004,-0.09675],[51.514210000000006,-0.09680000000000001],[51.51424,-0.09685],[51.514250000000004,-0.09688000000000001],[51.51428000000001,-0.09690000000000001],[51.514300000000006,-0.09692],[51.51433,-0.09693],[51.51437000000001,-0.09694000000000001],[51.514410000000005,-0.09695000000000001],[51.51447,-0.09694000000000001],[51.514520000000005,-0.09694000000000001],[51.51462,-0.09693],[51.51462,-0.09693],[51.514610000000005,-0.09681000000000001],[51.51456,-0.09655000000000001],[51.514540000000004,-0.09644000000000001],[51.514480000000006,-0.09621],[51.514430000000004,-0.09595000000000001],[51.514410000000005,-0.09586000000000001],[51.51435000000001,-0.09552000000000001],[51.514320000000005,-0.09534000000000001],[51.51429,-0.09508000000000001],[51.51422,-0.09473000000000001],[51.5142,-0.09461000000000001],[51.51418,-0.09445],[51.514140000000005,-0.09419000000000001],[51.514140000000005,-0.09419000000000001],[51.51437000000001,-0.09411000000000001],[51.51455000000001,-0.09404000000000001],[51.51456,-0.09404000000000001],[51.51458,-0.09402],[51.514590000000005,-0.09401000000000001],[51.514630000000004,-0.09396],[51.514660000000006,-0.09394000000000001],[51.51476,-0.09382000000000001],[51.51485,-0.09374],[51.51489,-0.0937],[51.51494,-0.09365000000000001],[51.51500000000001,-0.09361000000000001],[51.51507,-0.09357000000000001],[51.515100000000004,-0.09354000000000001],[51.51512,-0.09353],[51.515170000000005,-0.09350000000000001],[51.51527,-0.09345],[51.51532,-0.09343000000000001],[51.515370000000004,-0.09340000000000001],[51.51543,-0.09336000000000001],[51.51543,-0.09336000000000001],[51.51538000000001,-0.09323000000000001],[51.5153,-0.09307000000000001],[51.51527,-0.09301000000000001],[51.515260000000005,-0.09296],[51.515240000000006,-0.09293000000000001],[51.51523,-0.09288],[51.51520000000001,-0.09273],[51.51518,-0.0926],[51.515150000000006,-0.09245],[51.51511000000001,-0.09213],[51.51503,-0.09135],[51.514990000000004,-0.09107000000000001],[51.51494,-0.09061000000000001],[51.51491000000001,-0.09035000000000001],[51.51491000000001,-0.09035000000000001],[51.51489,-0.09018000000000001],[51.514810000000004,-0.08967000000000001],[51.514790000000005,-0.08956],[51.514770000000006,-0.08943000000000001],[51.51475000000001,-0.08932000000000001],[51.51475000000001,-0.08926],[51.51473000000001,-0.08912],[51.514720000000004,-0.08901],[51.514700000000005,-0.08884],[51.514680000000006,-0.08856000000000001],[51.51467,-0.08845],[51.51467,-0.0884],[51.51465,-0.08808],[51.51464000000001,-0.08783],[51.514630000000004,-0.08779],[51.514630000000004,-0.08779],[51.51447,-0.08767000000000001],[51.51433,-0.08758],[51.514140000000005,-0.08743000000000001],[51.513920000000006,-0.08728000000000001],[51.513920000000006,-0.08728000000000001],[51.513960000000004,-0.08704],[51.514010000000006,-0.08681000000000001],[51.514030000000005,-0.08672],[51.514050000000005,-0.08665],[51.514070000000004,-0.08657000000000001],[51.514100000000006,-0.08646000000000001],[51.51411,-0.0864],[51.514120000000005,-0.08633],[51.514120000000005,-0.08620000000000001],[51.514140000000005,-0.08593],[51.514160000000004,-0.08578000000000001],[51.514160000000004,-0.08567000000000001],[51.514190000000006,-0.08545000000000001],[51.5142,-0.08537],[51.51424,-0.08509000000000001],[51.51429,-0.08482],[51.51431,-0.08469],[51.51435000000001,-0.08441000000000001],[51.5144,-0.08415],[51.51442,-0.08402000000000001],[51.51442,-0.08396],[51.514430000000004,-0.08391000000000001],[51.514430000000004,-0.08386],[51.514430000000004,-0.08380000000000001],[51.51442,-0.08374000000000001],[51.5144,-0.08366000000000001],[51.5144,-0.08366000000000001],[51.51446000000001,-0.08358],[51.51453000000001,-0.0835],[51.51464000000001,-0.08336],[51.51473000000001,-0.08322],[51.51489,-0.083],[51.51493000000001,-0.08295000000000001],[51.51493000000001,-0.08295000000000001],[51.514880000000005,-0.08285000000000001],[51.5148,-0.08264],[51.51478,-0.08261],[51.514770000000006,-0.08257],[51.514770000000006,-0.08256000000000001],[51.51476,-0.08252000000000001],[51.51475000000001,-0.08248000000000001],[51.51474,-0.08237000000000001],[51.514720000000004,-0.08226000000000001],[51.51469,-0.08214],[51.51467,-0.08207],[51.514660000000006,-0.08204],[51.51464000000001,-0.08201000000000001],[51.51462,-0.08198000000000001],[51.514590000000005,-0.08195000000000001],[51.51455000000001,-0.08191000000000001],[51.51451,-0.08188000000000001],[51.51451,-0.08188000000000001],[51.514520000000005,-0.08135],[51.514520000000005,-0.08132],[51.51451,-0.08129],[51.514500000000005,-0.08125],[51.51449,-0.08118],[51.514430000000004,-0.08099],[51.514430000000004,-0.08099],[51.51455000000001,-0.0809],[51.5146,-0.08088000000000001],[51.51464000000001,-0.08085],[51.51475000000001,-0.08080000000000001],[51.51478,-0.08078]],
    };
  },
  watch: {},
  methods: {
    btnMaps(stype) {
      this.isMaps = stype;
      this.filterMap();
    },

    filterMap() {
      this.isMaps = true;
      //this.btnMaps(true);
      this.markers = [];
      this.loadDataOrder();
      // const markerPickup = {
      //     lat: -6.265,
      //     lng: 107.132,
      //     label:"PICKUP",
      //   };

      //   const markerDestination = {
      //     lat: -6.78078,
      //     lng: 107.256,
      //     label:"DESTINATION",
      //   };

      // this.center = markerPickup;
      // this.startLocation = markerPickup;
      // this.endLocation = markerDestination;

      let gps_vendor = "CAR";
      let vehicle_no = "B9204FYV";
      //let gps_vendor = "INOVATRACK";
      //let vehicle_no = "B9902UEH";
      let startDate = moment(String(this.pickupdestination.startDate)).format(
        "YYYY-MM-DD H:mm:ss"
      );
      let endDate = moment(String(this.pickupdestination.endDate)).format(
        "YYYY-MM-DD H:mm:ss"
      );

      const baseURI =
        this.$settings.endPointCt +
        `real-monitoring/history/` +
        vehicle_no +
        `/` +
        gps_vendor +
        `/` +
        startDate +
        `/` +
        endDate;

      return this.$http.get(baseURI).then((response) => {
        this.startLocation = [];
        this.endLocation = [];
        this.waypnt = [];

        this.dataAll = response.data.datas;

        if (this.dataAll.length > 0) {
          const markerPickup = {
            lat: this.dataAll[0].latitude,
            lng: this.dataAll[0].longitude,
            label: "PICKUP",
          };
          this.startLocation = markerPickup;
          var first_real_monitoring_id =this.dataAll[0].real_monitoring_id;
          var end_real_monitoring_id =this.dataAll[0].real_monitoring_id;
          
          this.dataAll.forEach((res) => {
           
           if(res.real_monitoring_id != first_real_monitoring_id  && res.real_monitoring_id != end_real_monitoring_id){
              const markerWay = {
                lat: res.latitude,
                lng: res.longitude,
              };

              this.waypnt.push({
                location: {
                  lat: markerWay.lat,
                  lng: markerWay.lng,
                },
                stopover: true,
              });

           }
           

            // this.endLocation = markerDestination;

            
          });

          const markerDestination = {
            lat: this.dataAll[this.dataAll.length - 1].latitude,
            lng: this.dataAll[this.dataAll.length - 1].longitude,
            label: "DESTINATION",
          };

          this.endLocation = markerDestination;
        this.loadMapsGoogle();
          




        }else{
          this.dataAll = [];
          this.loadError('No Data Selected');
        }
      });
    },

    fade(sType) {
      this.isLoading = sType;
    },

    loadingSubmiting() {
      this.$swal({
        icon: "warning",
        backdrop: true,
        title: "Pleasee Wait",
        html: "<h2>SUBMITTING...</h2>",
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
      });
    },



    updateStatus() {
      this.loadingSubmiting();
      let dataSend = {
        truck_status: this.forms.tms_status,
      };
      const baseURI =
        this.$settings.endPointCt +
        `master-truck/update-status/` +
        "B9204FYV";
      return this.$http.post(baseURI, dataSend).then((response) => {
        var msg = response.data.datas.messages;
        this.success(msg);
      });
    },

    initMarker(loc) {
      this.existingPlace = loc;
    },

    setLocationLatLng: function () {
      navigator.geolocation.getCurrentPosition((geolocation) => {
        this.center = {
          lat: geolocation.coords.latitude,
          lng: geolocation.coords.longitude,
        };
      });
      // this.locations = [
      //   {
      //     id:1,
      //     lat: -6.2066575,
      //     lng: 106.7759629,
      //     label: "B 123123 EG",
      //     rotate:20,
      //     color:"badge bg-primary"
      //   },
      //   {
      //     id:2,
      //     lat: -6.181783879012301,
      //     lng: 106.79797850513704,
      //     label: "B 22222 EH",
      //     rotate:40,
      //     color:"badge bg-success"
      //   },
      //   {
      //     id:3,
      //     lat: -6.1893281,
      //     lng: 106.764631,
      //     label: "B 12223 EJ",
      //     rotate:90,
      //     color:"badge bg-warning"
      //   },
      //   {
      //     id:4,
      //     lat: -6.1810517,
      //     lng: 106.7679362,
      //     label: "F 231312 EG",
      //     rotate:70,
      //     color:"badge bg-info"
      //   },
      // ];
    },

    onSelectBranch(ev) {
      this.branchFilter.push({
        branch_id: ev.branch_id,
      });
      this.changeFilterLocation();
    },

    changeFilterLocation() {
      let dataSend = {
        branch: this.branchFilter,
        type_truck: this.type_truckFilter,
        status: this.statusFilter,
      };
      //this.realMonitoring =[];
      this.locations = [];
      this.rowsTable = [];

      this.loadFilter(dataSend);
    },

    loadFilter(data) {
      const baseURI = this.$settings.endPointCt + `real-monitoring`;
      return this.$http.post(baseURI, data).then((response) => {
        this.realMonitoring = response.data.datas.data;
        this.totalRecords = response.data.datas.total;
        this.rows = response.data.datas.data;
        this.loadFetchLocation();
        this.loadFetchLocationTable();
      });
    },

    loadFilterClick(data) {
      const baseURI = this.$settings.endPointCt + `real-monitoring`;
      return this.$http.post(baseURI, data).then((response) => {
        this.realMonitoring = response.data.datas.data;
        this.totalRecords = response.data.datas.total;

        this.loadFetchLocation();
        this.loadFetchLocationTable();
      });
    },

    onUnselectBranch(ev) {
      this.branchFilter = this.branchFilter.filter(
        (res) => res.branch_id !== ev.branch_id
      );
      this.loadFetchLocation();
    },

    onUnselectTypeTruck(ev) {
      this.typeTruckFilter = this.typeTruckFilter.filter(
        (res) => res.type_truck_id !== ev.type_truck_id
      );
      this.loadFetchLocation();
    },

    onUnselectStatus(ev) {
      this.statusFilter = this.statusFilter.filter(
        (res) => res.status_name !== ev.status_name
      );
      this.loadFetchLocation();
    },

    detailData(index, row) {
      var params = this.$onRandom(row.id);
      window.location.href = "/monitoring/detail/" + params;
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    searchVehicleNo(ev) {
      this.isMaps = true;
      this.zoom = 15;
      (this.center = {
        lat: ev.lat,
        lng: ev.lng,
      }),
        (this.locations = []);
      let dataSend2 = {
        vehicle_no: ev.vehicle_no,
      };

      this.loadFilterClick(dataSend2);
    },

    searchVehicleNoByText() {
      this.locations = [];
      let dataSend2 = {
        vehicle_no: this.searchVhicle,
      };
      this.loadFilter(dataSend2);
    },

    onSelectTypeTruck(ev) {
      this.type_truckFilter.push({
        type_truck_id: ev.type_truck_id,
      });
      this.changeFilterLocation();
    },

    onSelectStatus(ev) {
      this.statusFilter.push({
        status_name: ev.status_name,
      });
      this.changeFilterLocation();
    },

    locateGeoLocation(latitude, longitude) {
      const marker = {
        lat: latitude,
        lng: longitude,
      };
      this.locationMarkers.push({ position: marker });
      this.locPlaces.push(this.existingPlace);
      this.center = marker;
      this.existingPlace = null;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.isLoading = false;
      }, 1000); // hide the message after 3 seconds
    },

    fetchIt() {
      // const userDatas = this.$getUserInfo();
      // this.detailUser = userDatas.sub;
      // // this.permision_role = userDatas.sub.permision_role;
      // let rolePermision = [];
      // userDatas.sub.permision_role.forEach(function (permision) {
      //   if (permision.permission.controller == "PackageController") {
      //     rolePermision = permision;
      //     // console.log(permision);
      //   }
      // });
      // if (!rolePermision.method_read) {
      //   this.$router.push("/authorized-error");
      // }
      // this.permision_role = rolePermision;
    },

    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
      this.loadLocationTable();
    },

        onColumnFilter(params) {
      params.page = 1;
      this.updateParams(params);
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
    },

    onSortChange(params) {
      this.updateParams({
        sort: {
          type: params[0].type,
          field: params[0].field,
        },
      });
    },

    onPerPageChange(params) {
      this.updateParams({ per_page: params.currentPerPage });
    },

    loadStatus() {
      const baseURI = this.$settings.endPointCt + `master-status`;

      return this.$http.get(baseURI).then((response) => {
        this.fetchStatus = response.data.datas.data;
      });
    },

    pickupChange() {},

    loadDataOrder() {
      let startDate = moment(String(this.pickupdestination.startDate)).format(
        "YYYY-MM-DD H:mm:ss"
      );
      let endDate = moment(String(this.pickupdestination.endDate)).format(
        "YYYY-MM-DD H:mm:ss"
      );

      const baseURI =
        this.$settings.endPointCt +
        `blujay-order/history/` +
        startDate +
        `/` +
        endDate +
        `?vehicle_no=` +
        this.forms.vehicle_no;

      //http://localhost:8080/blujay-order/history/2022-01-01%09:00:00/2022-08-01%09:00:00?vehicle_no=B9340IG&tms_status=ON DUTY

      return this.$http.get(baseURI).then((response) => {
        
        this.fetchOrder = [];

        response.data.datas.data.forEach((res) => {
          res.order_detail.forEach((res2) => {
             var data={
              order_number: res2.order_number,
              customer_name: res2.customer_name,
              product_type:res2.product_type,
              name_rute:res.name_rute,
              pickup_date:res.pickup_date,
              delivery_date:''
             }

              this.fetchOrder.push(data);
          });
          
        });
        
  
      });
    },

    loadData(vehicle_no) {
      const baseURI =
        this.$settings.endPointCt + `blujay-order/detail-active/` + vehicle_no;

      return this.$http
        .get(baseURI)
        .then((response) => {
          this.loadDataDetail(response.data.datas.blujay_order_id);

          //console.log(this.forms);
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.status === 422) {
              this.loadError(
                "No Blujay Order with this vehicle number:" + vehicle_no
              );
            } else if (error.response.status === 500) {
              this.$router.push("/server-error");
            } else {
              this.$router.push("/page-not-found");
            }
          }
        });
    },

    loadError(pesan) {
      this.$swal({
        icon: "warning",
        backdrop: true,
        title: "Warning",
        html: pesan,
        showConfirmButton: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
      });
    },

    loadDataDetail(blujay_order_id) {
      const baseURI =
        this.$settings.endPointCt + `blujay-order/detail/` + blujay_order_id;

      return this.$http.get(baseURI).then((response) => {
        this.forms = response.data.datas;

        this.loadDataOrder();
      });
    },


    loadDataDetailMonitoring(id) {
      const baseURI =
        this.$settings.endPointCt + `real-monitoring/detail/`+id;

      return this.$http.get(baseURI).then((response) => {
         this.detailMonitoring = response.data.datas;
    
      });
    },

    logout() {
      this.$logoutUser();
      this.$router.push("/");
    },

    loadMapsGoogle(){

      this.$loaderMaps
  .load()
  .then((google) => {

    // var fiestData = this.locationData[0]
    // var fiestDataLast = this.locationData[this.locationData.length - 1]

      var myLatLng = { lat: this.startLocation.lat, lng: this.startLocation.lng };
      var myLatLngLast = { lat: this.endLocation.lat, lng: this.endLocation.lng }; 

      const map = new google.maps.Map(document.getElementById("map"), {
          zoom: 15,
          center: myLatLng,
          draggable: true,
          mapTypeId: google.maps.MapTypeId.ROADMAP
      });
       var lineSymbol = {
    path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW
  };
var linecolor = "blue";

 const image = {
          url: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png",
          // This marker is 20 pixels wide by 32 pixels high.
          size: new google.maps.Size(30, 30),
          // The origin for this image is (0, 0).
          origin: new google.maps.Point(0, 0),
          // The anchor for this image is the base of the flagpole at (0, 32).
          anchor: new google.maps.Point(0, 32),
        };


          var marker = new google.maps.Marker({
            position: myLatLng,
            icon: image,
            map: map,
            title:this.startLocation.label,
            clickable: true
          });
var infowindow = new google.maps.InfoWindow({
              content: `<span class="badge" style="background-color:red;color:white;">${this.startLocation.label}</span>`,
              maxWidth: 200,
            });
              infowindow.open({
              anchor: marker,
              map,
              shouldFocus: false,
            });
   
           marker = new google.maps.Marker({
            position: myLatLngLast,
            icon: image,
            map: map,
            title:this.endLocation.label,
            clickable: true
          });
  infowindow = new google.maps.InfoWindow({
              content: `<span class="badge" style="background-color:red;color:white;">${this.endLocation.label}</span>`,
              maxWidth: 200,
            });
              infowindow.open({
              anchor: marker,
              map,
              shouldFocus: false,
            });


const flightPlanCoordinates = [];
      for (let i = 0; i < this.waypnt.length; i++) {
          var data = this.waypnt[i];
    




          flightPlanCoordinates.push({ lat: data.location.lat, lng:data.location.lng});

      }

     


        const flightPath = new google.maps.Polyline({
    path: flightPlanCoordinates,
    geodesic: true,
    icons: [{
        icon: lineSymbol,
        repeat: '35px',
        offset: '100%'
      }],
    strokeColor: linecolor,
    strokeOpacity: 1.0,
    strokeWeight: 2,
  });

  flightPath.setMap(map);



  })
  .catch(e => {
    console.log(e)
  });


    },



    loadMapsGoogle2(){

      this.$loaderMaps
  .load()
  .then((google) => {
  

    this.zoom = 15;
    const myLatLng = {lat:51.512802,lng:-0.091324};
    const locationArray = this.locationData.map(
      (l) => new google.maps.LatLng(l[0], l[1])
    );
      const map = new google.maps.Map(document.getElementById("map"), {
          zoom: 15,
          center: myLatLng,
          draggable: true,
          mapTypeId: google.maps.MapTypeId.ROADMAP
      });

    const line = new google.maps.Polyline({
      strokeOpacity: 0.5,
      path: [],
      map: map,
    });

    locationArray.forEach((l) => line.getPath().push(l));

    const start = new google.maps.LatLng(51.513237, -0.099102);
    const end = new google.maps.LatLng(51.514786, -0.080799);
        var marker = new google.maps.Marker({
            position: start,
            // icon: image,
            map: map,
            title:"PICKUP",
            clickable: true
          });
            var infowindow = new google.maps.InfoWindow({
              content: `<span class="badge" style="background-color:red;color:white;">PICKUP</span>`,
              maxWidth: 200,
            });
              infowindow.open({
              anchor: marker,
              map,
              shouldFocus: false,
            });
           marker = new google.maps.Marker({
            position: end,
            // icon: image,
            map: map,
            title:"DROP",
            clickable: true
          });
  infowindow = new google.maps.InfoWindow({
              content: `<span class="badge" style="background-color:red;color:white;">DROP</span>`,
              maxWidth: 200,
            });
              infowindow.open({
              anchor: marker,
              map,
              shouldFocus: false,
            }); 

        const flightPath = new google.maps.Polyline({
    path: locationArray,
    geodesic: true,
    icons: [{
        icon: {
          url: 'https://i.imgur.com/eTYW75M.png',
          path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
          // This marker is 20 pixels wide by 32 pixels high.
          animation: google.maps.Animation.DROP,
          // size: new google.maps.Size(256, 256),
          scaledSize: new google.maps.Size(128, 128),
          // The origin for this image is (0, 0).
          origin: new google.maps.Point(0, 0),
          // The anchor for this image is the base of the flagpole at (0, 32).
          anchor: new google.maps.Point(53, 110),
        },
        repeat: '35px',
        offset: '100%'
      }],
    strokeColor: "blue",
    strokeOpacity: 1.0,
    strokeWeight: 2,
  });

  flightPath.setMap(map);
 


  })
  .catch(e => {

    console.log(e)
  });


    },


  // play animation
  play() {
    this.marker.start();
  },

  // pause animation
  pause() {
    this.marker.pause();
  },

  // reset animation
  reset() {
    this.marker.reset();
  },

  // jump to next location
  next() {
    this.marker.next();
  },

  // jump to previous location
  prev() {
    this.marker.prev();
  },
  // fast forward
  fast() {
    this.speedMultiplier *= 2;
    this.marker.setSpeedMultiplier(this.speedMultiplier);
  },
  // slow motion
  slow() {
    this.speedMultiplier /= 2;
    this.marker.setSpeedMultiplier(this.speedMultiplier);
  },
 


  },
  events: {},
  created: function () {},
  mounted() {
    // var params = this.$onBehind(this.$route.params.id);
    this.loadDataDetailMonitoring("189");
    this.loadData("B9204FYV");
    this.loadStatus();
    // const start = {
    //   lat: -6.2066575,
    //   lng: 106.7759629,
    // };

    // this.startLocation = start;

    // const end = {
    //   lat: -6.1810517,
    //   lng: 106.7679362,
    // };

    // this.endLocation = end;
    //this.setLocationLatLng();
    //this.locateGeoLocation(5.54829, 95.323753);
    this.fetchIt();
    this.loading();
    this.loadMapsGoogle2()
  },
};
</script>
<style >
button.gm-ui-hover-effect {
  visibility: hidden;
}
</style>